import React, { ReactNode } from "react"
import Modal from "react-bootstrap/Modal"

interface CatchModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: ReactNode
  size?: "sm" | "lg" | "xl"
  centered?: boolean
  footer?: ReactNode
}

const CatchModal: React.FC<CatchModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  size,
  centered = true,
  footer,
}) => {
  if (!isOpen) return null

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered={centered}
      size={size}
      backdropClassName="modal-backdrop-zindex"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">{title}</h5>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  )
}

export default CatchModal
